import content from "../content/yhteystiedot";
import siteConfig from "../lib/siteConfig";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import Address from "../components/Address";
import Hours from "../components/Hours";
import RichText from "../components/RichText";
import Icon from "../components/Icon";
import PreviewBanner from "../components/PreviewBanner";
import Button from "../components/Button";
import { formatPhoneNumber } from "../components/phoneUtils.js";

import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { Link } from "lucide-react";

export default function ResursLuotto({ companyInfo, pageContent, preview }) {
  //const cleanedNumber = formatPhoneNumber(companyInfo.phone);
  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        {pageContent.hero && (
          <section>
            <HeroSection content={pageContent.hero} />
          </section>
        )}
        <section className="page-section page-content page-width page-width--narrow">
          {!pageContent.hero && (
            <h1 className="page-heading">{pageContent.title}</h1>
          )}
          <RichText
            className="mb-4 md:text-lg text-block"
            value={pageContent.introText}
          />
          <div className="mb-6">
            <Button href={"https://apply.resurs.com/XVP6H"}>
              {"Hae luottoa täältä"}
            </Button>
          </div>
          <div>
            <h2 className="section-heading">Luoton kustannukset</h2>
            <div className="table-container overflow-x-auto">
              <table className="table">
                <tbody>
                  <tr>
                    <th>Maksuvaihtoehto</th>
                    <th>Vuosikorko</th>
                    <th>Luottokulu/kk</th>
                  </tr>
                  <tr>
                    <td>30–60 pv</td>
                    <td>0%</td>
                    <td>0 €</td>
                  </tr>
                  <tr>
                    <td>12 kk</td>
                    <td>0%</td>
                    <td rowSpan={3}>
                      0,28 %/kk luottorajasta, kuitenkin enintään 12,50 €/kk.
                    </td>
                  </tr>
                  <tr>
                    <td>24 kk</td>
                    <td>12,90 %</td>
                  </tr>
                  <tr>
                    <td>48 kk</td>
                    <td>
                      15,00% + KSL viitekorko<sup>*</sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="my-6">
              <p className="text-sm">
                <sup>*</sup> KSL viitekorolla tarkoitetaan kuluttajansuojalaissa
                viitattua korkolain 12 §:n mukaista viitekorkoa, jonka Suomen
                Pankki julkistaa kahdesti vuodessa ja joka on voimassa 6
                kuukautta kerrallaan. Sovellettava viitekorko voi olla enintään
                5 % eli luoton vuosikorko voi olla enintään 20 %, kuten
                kuluttajansuojalaissa säädetään.
              </p>
            </div>
            <div className="text-block">
              <p>
                <strong>Esimerkkiostos:</strong> 1500 €, 12 kk
                maksuvaihtoehdolla. Vuosikorko: 0 %. Luottokulu/kk: 5,60 €.
                Todellinen vuosikorko: 4,01 %. Luoton kustannukset: 61,60 €.
                Maksettava yhteensä: 1562 €. Osamaksuerä/kk: 130,60 €, 12 erää.
                Luottokulu on 0,28 %/kk sovitusta luottorajasta, kuitenkin
                enintään 12,50 €/kk. Luottokulu veloitetaan kuukausilaskuilla.
                Eläinlääkäritili on jatkuva luotto, jonka minimiluottoraja on
                2000 €. Luoton muusta käytöstä voi seurata korkeampi tai alempi
                todellinen vuosikorko. Luotto ei ole käytössä Ahvenanmaalla.
                Luotonantaja: Resurs Bank AB Suomen sivuliike.
              </p>
              <p className="rich-text">
                <a
                  href={"https://www.resursbank.fi/resurs-partner"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Lue lisää rahoituskumppanistamme Resursista
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [companyInfo, pageContent] = await Promise.all([
    getCompanyInfo(preview),
    getPageContent("resurs", preview),
  ]);
  //console.log("📄 fetched pageContent:", pageContent.introText);
  return {
    props: {
      companyInfo,
      pageContent,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
